module.exports = __webpack_public_path__ + "fonts/7370c36.woff2";